import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";
import {AirlineLogoLargeMulticolorIcon} from "../../../assets/svg/airline-logo-large-multicolor.icon";
import {CloseSideMenuButtonComponent} from "../../burger-menu/close-side-menu-button.component";
import {useServices} from "../../../hooks/use-services.hook";

const SideMenuHeaderBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-shadow: ${props => props.theme.boxShadow.dropShadow};
    padding: calc(env(safe-area-inset-top) + ${props => props.theme.spacing.spacing16}) 
            ${props => props.theme.spacing.spacing16} 
            ${props => props.theme.spacing.spacing16} 
            ${props => props.theme.spacing.spacing16};
`

const CloseButtonWrapperBox = styled.div`
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
    margin-bottom: calc(-1 * ${props => props.theme.spacing.spacing12});
`



export const AgencySideMenuHeaderComponent: React.FC = observer(() => {
    const services = useServices();


    return (
        <SideMenuHeaderBox>
            <AirlineLogoLargeMulticolorIcon size={2}/>
            <CloseButtonWrapperBox>
                <CloseSideMenuButtonComponent sideMenuController={services.sideMenu.agencyMainSideMenuController} />
            </CloseButtonWrapperBox>

        </SideMenuHeaderBox>
    )
})